import {
  GET_MY_APPROVALS,
  GET_BOARD_APPROVALS,
  GET_APPROVAL_POLICIES,
  CREATE_APPROVAL_POLICY,
  UPDATE_APPROVAL_POLICY,
  DELETE_APPROVAL_POLICY,
  DECIDE_APPROVAL,
  COMMENT_APPROVAL,
} from "./ApprovalType";

const INITIAL_STATE = {
  myApprovals: [],
  myApprovalsTotal: 0,
  boardApprovals: [],
  policies: [],
  loading: false,
  error: null,
};

export const ApprovalReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_MY_APPROVALS: {
      return {
        ...state,
        myApprovals: action.Payload?.items || [],
        myApprovalsTotal: action.Payload?.total || 0,
      };
    }
    case GET_BOARD_APPROVALS: {
      return {
        ...state,
        boardApprovals: action.Payload?.items || [],
      };
    }
    case GET_APPROVAL_POLICIES: {
      return {
        ...state,
        policies: action.Payload?.policies || [],
      };
    }
    case CREATE_APPROVAL_POLICY: {
      const policy = action.Payload?.policy;
      if (!policy) return state;
      return {
        ...state,
        policies: [policy, ...state.policies],
      };
    }
    case UPDATE_APPROVAL_POLICY: {
      const policy = action.Payload?.policy;
      if (!policy) return state;
      return {
        ...state,
        policies: state.policies.map((p) =>
          String(p._id) === String(policy._id) ? { ...p, ...policy } : p,
        ),
      };
    }
    case DELETE_APPROVAL_POLICY: {
      const { PolicyID } = action.Payload || {};
      return {
        ...state,
        policies: state.policies.filter((p) => String(p._id) !== String(PolicyID)),
      };
    }
    case DECIDE_APPROVAL: {
      const { RequestID, data } = action.Payload || {};
      const updated = data?.request || null;
      if (!updated) return state;
      return {
        ...state,
        myApprovals: state.myApprovals
          .map((a) => (String(a._id) === String(RequestID) ? { ...a, ...updated } : a))
          .filter((a) => !(updated.status === "approved" || updated.status === "rejected") || String(a._id) !== String(RequestID)),
        boardApprovals: state.boardApprovals.map((a) =>
          String(a._id) === String(RequestID) ? { ...a, ...updated } : a,
        ),
      };
    }
    case COMMENT_APPROVAL: {
      const { RequestID, data } = action.Payload || {};
      const updated = data?.request || null;
      if (!updated) return state;
      return {
        ...state,
        myApprovals: state.myApprovals.map((a) =>
          String(a._id) === String(RequestID) ? { ...a, ...updated } : a,
        ),
      };
    }
    default:
      return state;
  }
};
